import { render, staticRenderFns } from "./groups.html?vue&type=template&id=02446746&scoped=true&external"
import script from "./groups.vue?vue&type=script&lang=js"
export * from "./groups.vue?vue&type=script&lang=js"
import style0 from "./groups.vue?vue&type=style&index=0&id=02446746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02446746",
  null
  
)

export default component.exports